/**
 * Публичный API webview-интеграции клиентского модуля.
 *
 * Системные действия/события моста доступны напрямую из `./vendor/web`
 * (`bridge`, `SYSTEM_ACTIONS`, `SYSTEM_EVENTS`).
 */
export { WEBVIEW_SESSION_MARKER } from './auth';
export { closeWebView, navigateBackInHost } from './base-actions';
export type { CloseNotification, CloseNotificationType } from './vendor/web';
export {
  notifyOrderCancelled,
  notifyOrderSubmitted,
  onOrderStatusChanged,
  useOrderStatusChanged
} from './contract';
export type {
  AutoCreditAction,
  AutoCreditEvent,
  OrderStatusChangedPayload
} from './contract';
export { canGoBackInApp, isInWebView } from './env';
export { setupBridge, WEBVIEW_ROOT_CLASS } from './setup';
export { WebViewBridgeProvider } from './WebViewBridgeProvider';
